import * as React from 'react'
import { cn } from '@/lib/utils'

const textareaVariants =
  'w-full border border-[var(--fl-border)] rounded-lg bg-[var(--fl-surface)] px-3 py-2.5 text-sm text-[var(--fl-text-1)] placeholder:text-[var(--fl-text-3)] focus:outline-none focus:ring-2 focus:ring-[var(--fl-heading)]/20 focus:border-[var(--fl-heading)] transition-colors disabled:opacity-50 disabled:cursor-not-allowed'

export type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement>

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => {
    return <textarea ref={ref} className={cn(textareaVariants, className)} {...props} />
  }
)
Textarea.displayName = 'Textarea'

export { Textarea, textareaVariants }
